import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';

const ProjectCard = ({ project }) => {
  return (
    <Link
      to={`/projeler/${project.id}`}
      className="group block bg-anthracite-light rounded-lg overflow-hidden border border-gold/10 hover:border-gold/30 transition-all duration-500 hover:shadow-xl hover:shadow-gold/5"
    >
      {/* Image Container */}
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={project.coverImage}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-anthracite via-transparent to-transparent opacity-60" />
        
        {/* Status Badge */}
        <div className="absolute top-4 left-4">
          <span
            className={`px-3 py-1 text-xs font-semibold rounded ${
              project.status === 'Biten'
                ? 'bg-green-500/20 text-green-400 border border-green-500/30'
                : 'bg-gold/20 text-gold border border-gold/30'
            }`}
          >
            {project.status}
          </span>
        </div>

        {/* Location */}
        <div className="absolute bottom-4 left-4 flex items-center space-x-1.5 text-white/80">
          <MapPin className="w-3.5 h-3.5" />
          <span className="text-xs">{project.location}</span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-lg font-semibold text-white group-hover:text-gold transition-colors duration-300 mb-2">
          {project.title}
        </h3>
        <p className="text-gray-400 text-sm leading-relaxed line-clamp-2 mb-4">
          {project.shortDescription}
        </p>
        
        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          {project.tags?.slice(0, 3).map((tag, index) => (
            <span
              key={index}
              className="px-2 py-0.5 text-xs text-gray-400 bg-anthracite rounded"
            >
              {tag}
            </span>
          ))}
        </div>

        {/* CTA */}
        <div className="flex items-center text-gold text-sm font-medium group-hover:translate-x-2 transition-transform duration-300">
          <span>Detaylar</span>
          <ArrowRight className="w-4 h-4 ml-2" />
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;